module.exports = __webpack_public_path__ + "static/media/goodnest_app6.e679aede.jpg";